import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import type { AuthData, User } from '../index';
import { ResetUserState, SetAuthDataFromUserState, SetUserFromUserState } from './user.actions';

export interface UserModel {
  user: User;
  authData: AuthData;
}

export const defaultUserState: UserModel = {
  user: {
    _id: '',
    department: '',
    displayName: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    nuid: '',
    email: '',
    isAuthenticated: false,
    isLoggedOff: false,
    modified: false,
    userRole: undefined,
    userToken: '',
    country: '',
  },
  authData: {
    access_token: '',
    expires_in: undefined,
    id_token: '',
    refresh_token: '',
    token_type: '',
  },
};

@State<UserModel>({
  name: 'userModel',
  defaults: defaultUserState,
})
@Injectable()
export class UserState {
  @Selector()
  static getUserFromUserState(state: UserModel): User {
    return state.user;
  }

  @Selector()
  static getAuthDataFromUserState(state: UserModel): AuthData {
    return state.authData;
  }

  @Action(SetUserFromUserState)
  setUser({ getState, patchState }: StateContext<UserModel>, action: SetUserFromUserState) {
    patchState({
      user: { ...getState().user, ...action.user },
    });
  }

  @Action(SetAuthDataFromUserState)
  setAuthData({ getState, patchState }: StateContext<UserModel>, action: SetAuthDataFromUserState) {
    patchState({
      authData: { ...getState().authData, ...action.authData },
    });
  }

  @Action(ResetUserState)
  resetState({ setState }: StateContext<UserModel>) {
    setState(defaultUserState);
  }
}

